module.exports = __webpack_public_path__ + "img/finance_bg.80344c2f.jpg";